import React, { Component } from "react";
import CSD from "./components/CSD";
import ChargeHistory from "./components/ChargeHistory";
import DistanceTable from "./components/DistanceTable";
import CurrentlyCharging from "./components/CurrentlyCharging";
import BatteryTemp from "./components/BatteryTemp";
import ChargeEvent from "./components/ChargeEvent";
import "./EVInsight.css";
import EVLoader from "../../../../EVLoader";
class EVInsight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded:false,
      expandedWidget:null,
      isExpanded:false
    };
    this.expandWidget=this.expandWidget.bind(this)
  }

  componentDidMount(){
    document.getElementsByClassName("rw-toolbar")[0].style.display="none"
    document.getElementsByClassName("rw-container")[0].style.top = "53px";
      document.getElementById("evInsight").addEventListener("click", function(event) {
        console.log("click event:",event.target.parentElement)
        if(event.target.id==="evContainer"){
          if(this.state.isExpanded){
            this.setState({isExpanded:false,expandedWidget:null})
          }
        }
      });
   
    
   

  }
  componentWillUnmount(){
    document.getElementsByClassName("rw-container")[0].style.top = "95px";

    document.getElementsByClassName("rw-toolbar")[0].style.display="flex"

  }
  getTableData(data) {
    let distance = [];
    for (const [key, value] of Object.entries(data)) {
      distance.push(value);
    }

    return distance;
  }

  expandWidget(widgetId){
    this.setState({isExpanded:!this.state.isExpanded})
    if(this.state.expandedWidget){
      this.setState({expandedWidget:null})
    }
    else{
      this.setState({expandedWidget:widgetId})
    }

  }
  render() {
    if(document.getElementsByClassName("rw-toolbar")[0]){
      document.getElementsByClassName("rw-toolbar")[0].style.display="none"

    }
    return (
    <div className="EVContainer" id="evInsight">
    {!this.props.isLoading && this.props.evDashboard!==null ? (
      <div className="EVInsight" id="evContainer" >
        {/* {this.props.isLive?
        <div> */}
        <CSD
          data={this.props.evDashboard.csd || {}}
          heads={this.props.evDashboard.meta.csd}
          isLive={this.props.isLive}
          setExpand={this.expandWidget}
          isExpanded={this.state.expandedWidget}
        /> 
        
        <CurrentlyCharging
          data={this.props.evDashboard.currentcharging || {}}
          heads={this.props.evDashboard.meta.currentcharging}
          isLive={this.props.isLive}
          setExpand={this.expandWidget}
          isExpanded={this.state.expandedWidget}



        />
           
        <BatteryTemp
          data={this.props.evDashboard.batterytemp || {}}
          heads={this.props.evDashboard.meta.batterytemp}
          isLive={this.props.isLive}
          setExpand={this.expandWidget}
          isExpanded={this.state.expandedWidget}



        />
      
         <ChargeEvent
          data={this.props.evDashboard.chargedistribution || {}}
          heads={this.props.evDashboard.meta.todaydistance}
          setExpand={this.expandWidget}
          isExpanded={this.state.expandedWidget}

        />
      
        <ChargeHistory 
        data={this.props.evDashboard.todaycharging || null}   
        setExpand={this.expandWidget}
        isExpanded={this.state.expandedWidget}

        /> 

        <DistanceTable
          data={this.props.evDashboard.todaydistance || {}}
          heads={this.props.evDashboard.meta.todaydistance}
          setExpand={this.expandWidget}
          isExpanded={this.state.expandedWidget}


        />
      </div>
    ) : (
      <div
        className="EVInsight"
        style={{ height: "90%", alignItems: "center" }}
      >
        {/* <div className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div> */}
                 <EVLoader countTime={20} />

        {/* <div className="loader">
          <div className="loader__lightning"></div>
        </div> */}
      </div>
     
    )}
    </div>
    )
   
    
  }
}

export default EVInsight;
